export class ListSavedQueriesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSavedQueriesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
